import zIndex from '@mui/material/styles/zIndex';
import { COLORS } from '../../../../utils/colors';

export const useEditorStyles = () => {
  return {
    editorHeight: {
      height: '-webkit-fill-available',
      width: '100%',
      display: 'contents',
      border: '0px solid #fff !important',
      '&:ql-container.ql-snow': {
        border: '0px solid #fff !important',
      },
    },
    toolbar: {
      display: 'flex',
      flexDirection: 'column',
      width: '50px',
    },
    rewriteButton: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: 'auto',
      color: COLORS.MEDIUM_GRAY,
      textTransform: 'capitalize',
      borderRadius: '2rem',
      border: `1.5px solid ${COLORS.MEDIUM_GRAY} !important`,
      marginRight: '1.5rem',
      paddingLeft: '0.5rem',
      paddingTop: '0.2rem',
      paddingBottom: '0.2rem',
      '&:hover': {
        backgroundColor: '#fff',
      },
    },
    editor: {
      flexGrow: 1,
      marginLeft: '10px',
    },
    canvasIcon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      padding: '0.4rem',
      color: COLORS.DARK_GREY,
      '&:hover': {
        backgroundColor: COLORS.LIGHT_GRAY,
      },
    },
    canvasHeadingsMenu: {
      bgcolor: COLORS.WHITE,
      position: 'absolute',
      top: 'calc(15.5rem + 2px)',
      left: 'calc(4rem + 2px)',
      zIndex: 10,
      border: `2px solid ${COLORS.LIGHT_GRAY}`,
    },
    menuFont: {
      '&:hover': {
        backgroundColor: COLORS.LIGHT_GRAY,
      },
    },
    MenuSize: {
      fontSize: '17px',
      '&:hover': {
        backgroundColor: COLORS.LIGHT_GRAY,
      },
    },
    canvasListMenu: {
      bgcolor: COLORS.WHITE,
      position: 'absolute',
      top: 'calc(3rem + 2px)',
      left: 'calc(14.25rem + 2px)',
      zIndex: 10,
      border: `2px solid ${COLORS.LIGHT_GRAY}`,
    },
    wordCount: {
      position: 'absolute',
      top: 'calc(7rem + 2px)',
      left: 'calc(55rem + 2px)',
    },
    canvasAlignMenu: {
      bgcolor: COLORS.WHITE,
      position: 'absolute',
      top: 'calc(3rem + 2px)',
      left: 'calc(17rem + 2px)',
      zIndex: 10,
      border: `2px solid ${COLORS.LIGHT_GRAY}`,
    },
    canvasSizeMenu: {
      bgcolor: COLORS.WHITE,
      position: 'absolute',
      top: 'calc(3rem + 2px)',
      left: 'calc(20rem + 2px)',
      zIndex: 10,
      border: `2px solid ${COLORS.LIGHT_GRAY}`,
    },
    canvasTools: {
      background: COLORS.WHITE,
      width: '100%',
      height: '3.65rem',
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'row',
      borderLeft: `0.5px solid #ebebeb`,
      borderRight: `0.5px solid #ebebeb`,
      position: 'relative',
      zIndex: 1,
      borderBottom: `1px solid #ebebeb`,
    },
    sidebarHangUp: {
      display: 'flex',
      alignItems: 'center',

      Padding: '1rem',
      borderRadius: '1.25rem',
      background: COLORS.PRIMARY,
      zIndex: 2,
      '&:hover': {
        backgroundColor: 'none',
      },
    },
    sidebarAutoSave: {
      alignItems: 'center',
      marginLeft: 'auto',
      mr: '1.0rem',
      padding: '0.5rem',
      borderRadius: '1.25rem',
      display: 'flex',
      justifyContent: 'flex-end',
      width: '50%',
      '&:hover': {
        backgroundColor: 'none',
      },
    },
    inputLink: {
      borderRadius: '4rem',
      '&: MuiOutlinedInput-root': {
        borderRadius: '4rem',
      },
    },
    canvasShapes: {
      bgcolor: COLORS.WHITE,
      position: 'absolute',
      top: 'calc(10.5rem + 2px)',
      left: 'calc(5rem + 2px)',
      zIndex: 10,
    },
    canvasShapesDocument: {
      bgcolor: COLORS.WHITE,
      position: 'absolute',
      top: 'calc(3.8rem + 2px)',
      left: 'calc(6.5rem + 2px)',
      zIndex: 10,
    },
    canvasPen: {
      bgcolor: COLORS.WHITE,
      position: 'absolute',
      top: 'calc(15.5rem + 2px)',
      left: 'calc(5rem + 2px)',
      padding: '1rem',
      height: '4rem',
      width: '10rem',
      textAlign: 'center',
      zIndex: 10,
    },
    canvasPenDocument: {
      bgcolor: COLORS.WHITE,
      position: 'absolute',
      top: 'calc(3.8rem + 2px)',
      left: 'calc(6rem + 2px)',
      padding: '1rem',
      height: '4rem',
      width: '10rem',
      textAlign: 'center',
      zIndex: 10,
    },
    canvaslayers: {
      bgcolor: COLORS.WHITE,
      position: 'absolute',
      top: 'calc(25.5rem + 2px)',
      left: 'calc(5rem + 2px)',
      width: '10rem',
      textAlign: 'center',
      zIndex: 10,
    },
    canvaslayersDocument: {
      bgcolor: COLORS.WHITE,
      position: 'absolute',
      top: 'calc(3.8rem + 2px)',
      left: 'calc(12rem + 2px)',
      width: '10rem',
      textAlign: 'center',
      zIndex: 10,
    },
    strokesLayer: {
      display: 'flex',
      width: '100%',
      padding: '.5rem',
      cursor: 'pointer',
    },
    downloadIcon: {
      width: '2.55rem',
      height: '2.55rem',
      border: `1px solid ${COLORS.LIGHT_GRAY}`,
      borderRadius: '50%',
    },
    page: {
      bgcolor: '#f00',
      width: '100%',
      overflowY: 'auto',
      overflowX: 'hidden',
      maxHeight: 'calc(100vh - 7rem)',
    },
    zoomIcon: {
      position: 'absolute',
      background: '#fff',
      border: 'solid 1px #e9e9e9',
      boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.1)',
      opacity: 0.9,
      right: 210,
      bottom: 10,
    },
    zoomSlider: {
      width: 170,
      background: '#fff',
      padding: '2px 7px 2px 7px',
      borderRadius: '1rem',
      border: 'solid 1px #e9e9e9',
      boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.1)',
      opacity: 0.9,
    },
    zoomSlider2: {
      alignItems: 'center',
      mb: 1,
      marginBottom: '0px !important',
    },
    zoomSlider3: {
      width: '150px',
      '& .MuiSlider-thumb': {
        width: 10,
        height: 10,
      },
      '& .MuiSlider-track': {
        height: 2,
      },
      '& .MuiSlider-rail': {
        height: 2,
        borderRadius: 4,
      },
    },
    pages: {
      transformOrigin: 'center center',
      width: '100%', // Ensure full width
    },
    scrollDown: {
      position: 'absolute',
      right: '4rem',
      bottom: '3rem',
      zIndex: 100,
    },
    pageStatus: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: 'calc(100vh - 6.75rem)',
      width: '100%',
    },
    editorCanvasWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    scrollButton: {
      position: 'absolute',
      top: '2rem',
      right: '10rem',
      backgroundColor: '#f00',
      zIndex: 1000,
      color: '#fff',
    },
    autoSave: {
      display: 'flex',
      bgcolor: COLORS.LIGHT_GRAY,
      borderRadius: '1.25rem',
      padding: '0.5rem',
      alignItems: 'center',
    },
    imageDimensions: {
      position: 'absolute',
      bottom: 8,
      right: 8,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      color: '#fff',
      padding: '4px 8px',
      borderRadius: '4px',
      fontSize: '12px',
      fontFamily: 'monospace',
      zIndex: 1,
    },
  };
};
